<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Verhuizen? Checklist nagaan!</h1>
      <p>
        Gaat u binnenkort verhuizen? Een checklist is dan onmisbaar! Zo’n
        controlelijst is voor iedereen natuurlijk anders, en daarom is het
        belangrijk dat u alles wat u te binnen schiet opschrijft, zodra u weet
        dat er een verhuizing op komst is. Wel zijn er natuurlijk een aantal
        aandachtspunten die voor iedereen gelden en dus onmisbaar zijn voor elke
        verhuis checklist. Op internet vindt u tientallen lijsten en wij zetten
        hier een aantal belangrijke punten voor u op een rijtje. Om te voorkomen
        dat u dingen vergeet en stress te vermijden, luidt het belangrijkste
        advies altijd: begin op tijd met de voorbereidingen!
      </p>

      <h2>Belangrijke punten</h2>
      <p>
        Om u een handje te helpen leest u hier een aantal belangrijke zaken die
        niet mogen ontbreken op uw verhuis checklist. In de eerste plaats kunt u
        niet vroeg genoeg offertes aanvragen van meerdere professionele
        verhuisfirma’s. Zo kunt u op tijd beginnen met het vergelijken van de
        tarieven en voorwaarden, zodat u op tijd afspraken kunt maken met
        voordelige en betrouwbare verhuizers. Vergeet ook niet tijdig te
        informeren naar een verhuisvergoeding bij uw werkgever en eventuele
        subsidiemogelijkheden. Om uw adreswijziging door te laten geven aan
        belangrijke organisaties en uw post na de verhuizing door te laten
        sturen, meldt u zich aan bij de verhuisdienst van Bpost. Enkele weken
        van tevoren kunt u de af- en aansluiting van gas, elektriciteit en water
        regelen en uw kennissen en familieleden informeren over de
        adreswijziging. Vlak voor de verhuizing en op de dag zelf hoeft u zich
        als het goed is alleen nog maar bezig te houden met de zaken die niet
        eerder mogelijk waren, en na de verhuizing is het onder andere
        belangrijk om eventuele schade zo snel mogelijk door te geven aan de
        verhuisfirma.
      </p>

      <h2>Verhuis checklist nu maken!</h2>
      <p>
        Gaat u pas over een half jaar verhuizen? Een checklist kunt u niet vroeg
        genoeg maken. Zet dus zo veel mogelijk op papier en voorkom allerlei
        ellende vlak voor, tijdens en na uw verhuizing.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Verhuizen? Checklist nagaan! Meer informatie op Verhuisvergelijker.be',
      headDescription:
        'Gaat u binnenkort verhuizen? Dan moet er zo veel worden geregeld, dat het handig is om een verhuis checklist na te gaan. Verhuisvergelijker.be geeft tips!',
    }
  },
}
</script>
